function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("linearGradient", {
  id: "9yn0c7o0qc",
  x1: "35.152%",
  x2: "121.5%",
  y1: "66.505%",
  y2: "-100.5%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#6A2D87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A93D69"
}));
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#9yn0c7o0qc)",
  d: "M22 10V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54zM9.07 16L12 14.12 14.93 16l-.89-3.36 2.69-2.2-3.47-.21L12 7l-1.27 3.22-3.47.21 2.69 2.2L9.07 16z"
});
const SvgNewProductWebcast = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewProductWebcast, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/new-product-webcast.c35fb611.svg";
export { ForwardRef as ReactComponent };